var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 19.89 33.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: #fff;        stroke-width: 0px;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.36,17.06h-2.89l-1.26-13.87h1.58c.35,0,.63-.28.63-.63V.63c0-.35-.28-.63-.63-.63H3.11c-.35,0-.63.28-.63.63v1.93c0,.35.28.63.63.63h1.58l-1.26,13.87H.53c-.3,0-.53.24-.53.54v2.11c0,.29.24.53.53.53h8.36l1.06,13.22,1.06-13.22h8.36c.3,0,.53-.24.53-.53v-2.11c0-.3-.24-.54-.53-.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPining);
export default __webpack_public_path__ + "static/media/Pining.5fec5a2474e571de6ea5594607675342.svg";
export { ForwardRef as ReactComponent };